import mutations from './proformaInvoice.mutations'
import actions from './proformaInvoice.actions'
import getters from './proformaInvoice.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
